module.exports = __webpack_public_path__ + "fonts/YesevaOne-Regular.ttf!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/YesevaOne-Regular.ttf
// module id = 48
// module chunks = 0